import { render } from "./MemoTable.vue?vue&type=template&id=0b2f328f&scoped=true"
import script from "./MemoTable.vue?vue&type=script&lang=js"
export * from "./MemoTable.vue?vue&type=script&lang=js"

import "./MemoTable.vue?vue&type=style&index=0&id=0b2f328f&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2f328f"]])

export default __exports__